var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 752,
    viewBox: "0 0 1920 752",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 752,
    fill: "url(#paint0_linear_2223_1393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2223_1393",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C382F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBg);
export default __webpack_public_path__ + "static/media/PurpleBg.6ed00b81b1b21bf418da0b28a7d63225.svg";
export { ForwardRef as ReactComponent };